/* eslint-disable no-restricted-globals */
import type FastbootService from 'ember-cli-fastboot';
import { modifier } from 'ember-modifier';

export default modifier(
  (
    element: HTMLElement,
    [className, offset, fastboot]: [string, number, FastbootService]
  ) => {
    function handleScroll() {
      // eslint-disable-next-line no-restricted-globals
      if (window.pageYOffset > offset) {
        element.classList.add(className);
      } else {
        element.classList.remove(className);
      }
    }
    if (!fastboot.isFastBoot) {
      window.addEventListener('scroll', handleScroll);

      return () => {
        window.removeEventListener('scroll', handleScroll);
      };
    }
  }
);
